import React, { Component } from 'react'


export default class PlanTop extends Component {

    state = {
        width : ['65%', '35%', '40%'],
        widthTxt : ['Engine', 'Store Front', 'Admin Panel']      
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.isPjt) {

            this.setState({
                width : ['65%', '35%', '40%'],
                widthTxt : ['Engine', 'Store Front', 'Admin Panel']
            })
        
        } else {
        
            this.setState({
                width : ['70%', '35%', '45%'],
                widthTxt : ['ECMA Script', 'Python', 'Mobile Apps']
            })
        
        }
    }

    render() {

        const perc = [46.7, 50]
        const perc2 = (100 - perc[0]) / 100 * 1005
        const perc3 = (100 - perc[1]) / 100 * 1005
 
        const PlanCircle = () => {

            return(

                <div className='PlanCircleBox'>

                    <svg className='PlanCircleProgress' width='400' height='400' viewBox='0 0 400 400'>
                        <circle cx='200' cy='200' r='160' fill='none' stroke='#5F6574' strokeWidth='40' />
                        <circle className='PlanCircleValue' cx='200' cy='200' r='160' fill='none' stroke='#22252C' strokeWidth='40'
                        style={{strokeDashoffset : this.props.isPjt ? perc2 : perc3 }} />
                    </svg>

                    <span className='PlanCircleTxt'>{ this.props.isPjt ? perc[0] : perc[1] } %</span>

                </div>

            )
        }

        const PlanBar = (props) => {

            return(

                <div className='PlanBar'>

                    <div className='PlanBarValue' style={{width: props.wid}}></div>

                    <div className='PlanBarTxt'>
                        <p>{props.txt}</p>
                        <p>{props.wid}</p>
                    </div>
                    
                </div>
            )
        }

		return (

            <div id='PlanTop'>

                <div id='PlanLeft'>
                    <PlanCircle />          
                </div>

                <div id='PlanRight'>
                    <div id='PlanBarBox'>
                        <PlanBar wid = {this.state.width[0]} txt = {this.state.widthTxt[0]} />
                        <PlanBar wid = {this.state.width[1]} txt = {this.state.widthTxt[1]}/>
                        <PlanBar wid = {this.state.width[2]} txt = {this.state.widthTxt[2]}/>

                    </div>
                </div>

            </div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/components/plan/PlanTop.js